module.exports = __webpack_public_path__ + "img/logo_full.f1d587f6.svg";